import { render, staticRenderFns } from "./CardListChallengePlans.vue?vue&type=template&id=1001f940&scoped=true"
import script from "./CardListChallengePlans.vue?vue&type=script&lang=js"
export * from "./CardListChallengePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1001f940",
  null
  
)

export default component.exports